export default __webpack_public_path__ + "static/media/circle-purple.341280ad.png";